// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./vendor/vi-kon/laravel-admin/src/resources/assets/icomoon/style.less
// module id = 317
// module chunks = 0